import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import ConsultationForm from "../components/ConsultationForm";
import "./style.css";
import CourseImg from "../assets/img/courseImg2.png";
import { COURSE_LIST } from "../constants/courses";
import CallIcon from "../assets/Icons/call-icon.svg"; 

const Container = (props) => {
  return (
    <div className="container">
      <p className="p-2 text-wrapper-12">{props.header}</p>

      <p className="from-initial">{props.desc}</p>
    </div>
  );
};

const Background = (props) => {
  return (
    <div className="background">
      <div className="heading">
        <p className="text-wrapper-9">Ready to Start Your Education Journey?</p>
      </div>

      <div className="book-a-free-wrapper">
        <p className="book-a-free">
          Book a free consultation with our education experts and take the first
          step
          <br />
          towards your dream university.
        </p>
      </div>

      <button onClick={props.onClickConsultation} className="button">
        <div className="text-wrapper-10">Book Free Consultation</div>

        <img
          className="SVG"
          alt="Svg"
          src="https://c.animaapp.com/XwKqq1VA/img/svg.svg"
        />
      </button>
    </div>
  );
};
export default function CourseFinder() {
  const formSectionRef = useRef(null);
  const navigate = useNavigate();
  const handleFocusSection = () => {
    formSectionRef.current.scrollIntoView({ behavior: "smooth" });
    formSectionRef.current.focus();
  };

  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);

  return (
    <div className="language-prep">
      <div className="language-rectangle">
        <section
          className=" pt-6 pb-0 text-center md:hidden"
          style={{ transform: "translateY(-20px)" }}
        >
          <h2 className="text-[28px] font-semibold text-[#051d62] leading-tight">
            Your gateway to <br />
            <span className="text-blue-700">Global Education</span>
          </h2>

          <p className="p-2 mt-4 text-gray-600 text-[25px] leading-relaxed">
            Empowering international students to achieve world-class education —
            with expert guidance at every stage of the journey.
          </p>

          <img
            className="w-full mt-4 rounded-lg"
            src={CourseImg}
            alt="Students"
          />
        </section>

        {/* DESKTOP HERO + TEXT */}
        <div className="hidden md:block">
          <div className="services-rectangle">
            <div className="frame">
              <div className="service-div-2">
                <div className="service-text-wrapper-2">Your gateway to</div>

                <div className="service-text-wrapper-3">Global Education</div>
              </div>

              <p className="p">
                Empowering international students to achieve world-class
                education — with expert guidance at every stage of the journey.
              </p>
            </div>

            <img
              className="services-rectangle-2"
              alt="Rectangle"
              src={CourseImg}
            />
          </div>
        </div>
      </div>

      <div className="course-finder-container-background space-y-16">
        <Container
          header={"Your Complete Partner in Global Education"}
          desc={
            " From first consultation through to graduation, we provide bespoke guidance and comprehensive support throughout your international education journey."
          }
        />

        <section className=" py-16 bg-white">
          <div className="flex flex-col items-center gap-8 md:grid md:grid-cols-3 md:gap-8 md:items-stretch">
            {COURSE_LIST.map((svc, idx) => (
              <div
                key={idx}
                className="p-6 border rounded-lg shadow hover:shadow-lg"
              >
                {/* <img className="image-overlay" alt="Overlay" src={svc.img} /> */}
                <div className="card-text-container">
                  <h3 className="card-text-wrapper font-semibold text-lg mb-3 py-2">
                    {svc.title}
                  </h3>
                  <p className="card-text-desc text-gray-600 mb-3">
                    {svc.desc}
                  </p>
                </div>
                <button
                  onClick={handleFocusSection}
                  className="card-btn card-btn-text text-white-700 font-medium"
                >
                  Learn more
                </button>
              </div>
            ))}
          </div>
        </section>

        <Background onClickConsultation={handleFocusSection} />

        <Container
          header={"Start your Education Journey Today"}
          desc={
            "Ready to take the next step? Book a free consultation with our education experts and let us help you achieve your Global study goals."
          }
        />
        <div ref={formSectionRef} className="card-form frame-4">
          <section id={"features-form-load"} style={{ width: "100%" }}>
            <ConsultationForm />
          </section>

          <div className="container-21">
            <div className="background-shadow-2">
              <div className="container-22">
                <img
                  className="overlay"
                  alt="Overlay"
                  src="https://c.animaapp.com/XwKqq1VA/img/overlay.svg"
                />

                <div className="container-23">
                  <div className="heading-3">
                    <div className="text-wrapper-25">Email Us</div>
                  </div>

                  <div className="container-24">
                    <a
                      href="mailto:info@globalstudyin.com"
                      className="text-blue-600 underline hover:text-blue-800 transition-colors duration-200"
                    >
                      info@globalstudyin.com
                    </a>
                  </div>

                  <div className="container-26">
                    <p className="text-wrapper-27">
                      We&#39;ll respond within 24 hours
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="background-shadow-2 custom-h-100">
              <div className="container-22">
                <img
                  className="overlay"
                  alt="Overlay"
                  src={CallIcon}
                />

                <div className="container-23">
                  <div className="heading-3">
                    <div className="text-wrapper-25">Contact Us</div>
                  </div>

                  <div className="container-24">
                    <div className="text-wrapper-26">+44 20 7277 6666</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="background-shadow-4">
              <div className="container-29">
                <div className="div-3">
                  <div className="text-wrapper-29">Why Students Choose Us</div>
                </div>

                <div className="container-30">
                  <div className="container-31">
                    <img
                      className="SVG-4"
                      alt="Svg"
                      src="https://c.animaapp.com/XwKqq1VA/img/svg-7.svg"
                    />

                    <div className="container-32">
                      <div className="text-wrapper-30">
                        10000+ Students Successfully Placed
                      </div>
                    </div>
                  </div>

                  <div className="container-31">
                    <img
                      className="SVG-4"
                      alt="Svg"
                      src="https://c.animaapp.com/XwKqq1VA/img/svg-8.svg"
                    />

                    <div className="container-32">
                      <div className="text-wrapper-30">
                        200+ Partner Universities
                      </div>
                    </div>
                  </div>

                  <div className="container-31">
                    <img
                      className="SVG-4"
                      alt="Svg"
                      src="https://c.animaapp.com/XwKqq1VA/img/svg-9.svg"
                    />

                    <div className="container-32">
                      <div className="text-wrapper-30">
                        25+ Years of Experience
                      </div>
                    </div>
                  </div>

                  <div className="container-31">
                    <img
                      className="SVG-4"
                      alt="Svg"
                      src="https://c.animaapp.com/XwKqq1VA/img/svg-10.svg"
                    />

                    <div className="container-32">
                      <div className="text-wrapper-30">
                        24/7 Student Support
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="course-finder-footer">
        <Footer />
      </div>
    </div>
  );
}
